import { useUnit } from 'effector-react';
import { ChangeEvent, memo, useCallback } from 'react';
import { $processedPostCardImage, setPostCardImage } from 'src/entity/PostCard';
import { Upload } from 'src/shared/ui/upload/Upload';

export const UploadImage = memo(() => {
  const [processedPostCardImage, onSetPostCardImage] = useUnit([
    $processedPostCardImage,
    setPostCardImage
  ]);

  const onUploadChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      e.preventDefault();
      const { files } = e.currentTarget;

      if (!files) {
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        onSetPostCardImage(reader.result as string);
      };
      reader.readAsDataURL(files[0]);
      e.currentTarget.value = '';
    },
    [onSetPostCardImage]
  );

  return <Upload img={processedPostCardImage} onChange={onUploadChange} />;
});
